// libraries
import styled from 'styled-components';
import { Avatar, Typography, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';
import { useDeviceSize } from '../../../../hooks/device-size';
import { renderHeaderSubscription } from '../../../shared/subscriptions';

export function UserPageHeader({ user }: any): JSX.Element {
	const isMobileDevice: boolean = useDeviceSize();

	return (
		<StyledSection>
			{isMobileDevice === false && (
				<Avatar size={64} src={user.image} icon={<UserOutlined />} />
			)}

			<div className="details-container">
				<h3>
					<span>{user.username}</span>
					<Typography.Text type="secondary">{user.municipality}</Typography.Text>

					<Typography.Text type="danger">
						{Boolean(user.banned) === true && txt('global.banned')}
					</Typography.Text>
				</h3>

				<Typography.Text ellipsis className="date-container">
					<Tooltip title={txt('global.created')}>
						<Typography.Text>{formatDate(user.created)}</Typography.Text>
					</Tooltip>

					<Tooltip title={txt('global.last active')}>
						<Typography.Text type="secondary">
							({formatDate(user.last_activity_date)})
						</Typography.Text>
					</Tooltip>
				</Typography.Text>
			</div>

			{user.subscription && renderHeaderSubscription(user.subscription, isMobileDevice)}
		</StyledSection>
	);
}

const StyledSection = styled.section`
	display: flex;
	align-items: center;
	gap: 1em;
	padding: 1rem 2rem;

	.details-container {
		display: flex;
		flex-direction: column;
		max-width: 70%;

		h3 {
			margin: 0;
			display: flex;
			flex-wrap: wrap;
			gap: 1ch;
		}

		.date-container {
			display: flex;
			gap: 1ch;
		}
	}
`;

const StyledSubscription = styled.div<{ color: string; background: string }>`
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		padding: 1ch 2ch;
		border-radius: 1ch;
		color: ${({ color }) => color};
		background-color: ${({ background }) => background};
	}
`;
